import { render, staticRenderFns } from "./OperationConfigDetail.vue?vue&type=template&id=43c31bc2&scoped=true"
import script from "./OperationConfigDetail.vue?vue&type=script&lang=js"
export * from "./OperationConfigDetail.vue?vue&type=script&lang=js"
import style0 from "./OperationConfigDetail.vue?vue&type=style&index=0&id=43c31bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c31bc2",
  null
  
)

export default component.exports